module.exports = __webpack_public_path__ + "static/media/punching-bag-1.520e2da4.png";